import React, { useState, useEffect } from "react";
import { Button, CircularProgress, Snackbar } from "@material-ui/core";
import AlertHelper from '../../../components/Alert';
import { getUserFactoryId } from '../../../../index';
import api from '../../../services/api';
import { getFile } from './action'
import { FontDownload } from "@material-ui/icons";
export default function ExportDMO(props) {
    const [factoryId, setFacotoryId] = useState('')
    const [Dowload, setDowload] = useState('')
    const [Api, setApi] = useState('')
    const [isSaving, setIsSaving] = useState(false);

    const [snackBar, setSnackBar] = useState({
        isOpen: false,
        message: '',
        vertical: 'top',
        horizontal: 'right',
        type: 'error'
    });

    // useEffect(() => {
    // }, []);

    /**
     * Update state snackbar for close
     */
    const handleCloseSnackbar = async () => {
        setTimeout(function () {
            setSnackBar({ ...snackBar, isOpen: false, message: '' })
        }, 3000);
    }


    async function Download() {
        setIsSaving(true);
        let factoryId = getUserFactoryId()
        let retorno = await api.get(`/idcard/export/${factoryId}`, { responseType: 'arraybuffer'}).then((e) => {
           
            console.log('Resposta',e.data)
            // let data = e.data
            // let type = "pdf" ? 'application/pdf' : '';
            let blob = new Blob([e.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            
            
            var downloadURL = URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.href = downloadURL;
            link.download = `Template_Factory_${getUserFactoryId()}_(${new Date().getDate()}-${new Date().getMonth() + 1}-${new Date().getFullYear()}).xlsx`;
            link.click();
            
        }).catch(error => {
            console.log(error);
            setSnackBar({
                ...snackBar,
                isOpen: true,
                message: "Erro na localização de dados dos ID Cards, tente novamente!",
                type: 'error'
            })
        });;
        // return retorno.request.response
        setIsSaving(false);
    }
    return (
        <div>
            {!isSaving &&
                <Button id="Salvar" onClick={() => { Download() }} variant="contained" class="btn btn-success btn-lg btn-block" color="primary" className='center'>Exportar ID Cards da minha fábrica (.xlsx)</Button>
            }
            {/* {Download()} */}
            {isSaving &&
                <div className='w-100 text-center mx-auto'>
                    <CircularProgress />
                </div>
            }
            <Snackbar
                open={snackBar.isOpen}
                anchorOrigin={{ vertical: snackBar.vertical, horizontal: snackBar.horizontal }}
                key={snackBar.vertical + snackBar.horizontal}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
            >
                <AlertHelper onClose={handleCloseSnackbar} severity={snackBar.type}>
                    {snackBar.message}
                </AlertHelper>
            </Snackbar>
        </div>
    )
}